export default function BookingSummarySkeleton() {
  return (
    <aside className="w-full rounded-[8px] bg-white p-4 lg:max-w-[400px]">
      {/* Title */}
      <div className="mb-5 h-6 w-1/2 animate-pulse rounded bg-gray-200" />

      {/* Ngày check-in/out */}
      <div className="rounded-[6px] bg-[#F3F3F3] p-3">
        <div className="flex flex-col gap-2 text-[12px] text-[#2D2E32] sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-1">
            <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
            <div className="h-3 w-12 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="hidden h-[1px] w-[9%] bg-[#3A3B3F] sm:block"></div>
          <div className="flex flex-col gap-1 text-right">
            <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
            <div className="h-3 w-12 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="mt-3 flex flex-col gap-2 border-t border-[#CED0D3] pt-3 text-[12px] text-[#2D2E32] sm:flex-row sm:items-center sm:justify-between">
          <div className="flex-1">
            <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-12 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="hidden h-[21px] w-[1px] bg-[#CED0D3] sm:block"></div>
          <div className="flex-1 text-left sm:text-right">
            <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-12 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Danh sách phòng */}
      <div
        className="custom-scroll mt-4 flex flex-col gap-3 overflow-y-auto"
        style={{ maxHeight: '300px' }}
      >
        {[...Array(2)].map((_, idx) => (
          <div key={idx} className="rounded-[8px] border border-[#CED0D3] p-3">
            <div className="flex items-start justify-between">
              <div className="flex gap-2">
                <div className="h-11 w-11 animate-pulse rounded bg-gray-200" />
                <div className="flex flex-col gap-2">
                  <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <div className="h-5 w-5 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-12 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
            <div className="mt-1 flex justify-between text-xs text-[#666B74]">
              <div className="h-3 w-24 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-10 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
        ))}
      </div>

      {/* Thông tin thanh toán */}
      <div className="mt-4 flex flex-col gap-2">
        <div className="h-6 w-1/3 animate-pulse rounded bg-gray-200" />
        <div className="flex justify-between">
          <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
        </div>
        <div className="border-t border-[#F3F3F3] text-sm text-[#2D2E32]">
          <div className="mt-2 flex justify-between font-semibold">
            <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
            <div className="h-5 w-16 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="mt-2 h-12 w-full animate-pulse rounded bg-gray-200" />
      </div>
    </aside>
  )
}
